import React, { Fragment } from 'react';
import omit from 'lodash/omit';
import {
  Button as MUIButton,
  Icon,
} from '@material-ui/core';
import {
  bool,
  func,
  node,
  oneOf,
  string,
} from 'prop-types';

import '../../../css/core/components/Button.scss';

const Button = (props) => {
  const {
    children,
    fullWidth,
    hasBorderColor,
    hasBorderRadius,
    icon,
    onClick,
    type,
    text,
    disabled,
    overrideClass,
  } = props;

  const ButtonIcon = () => {
    if (!icon) return null;
    return <Icon className="button-buttonIcon">{icon}</Icon>;
  };

  const getButtonClass = () => {
    const typeStyle = `button-${props.type}`;
    const buttonStyle = `
      ${typeStyle}
      ${disabled ? 'button-disabled' : ''}
      ${fullWidth ? 'button-fullWidth' : ''}
      ${hasBorderRadius ? 'button-borderRadius' : ''}
      ${hasBorderColor ? 'button-borderStyle' : ''}
    `;
    return buttonStyle;
  };

  const onButtonClick = (event) => {
    // If the Button is inside a Form, it will refresh the page unexpectedly, because of js form submission
    event.preventDefault();
    if (onClick !== null) onClick();
  };

  const defaultContent = (
    <Fragment>
      <ButtonIcon />
      { text }
    </Fragment>
  );

  const usedContent = children || defaultContent;

  const muiButtonProps = omit(props, ['overrideClass', 'styleOverride', 'classes', 'hasBorderColor', 'hasBorderRadius', 'id']);
  const buttonProps = {
    ...muiButtonProps,
    type: 'button',
    className: getButtonClass(),
    onClick: onButtonClick,
    style: props.styleOverride,
  };

  if (overrideClass) {
    buttonProps.className = `${buttonProps.className} ${props.className}`;
  }

  return (
    <MUIButton
      {...buttonProps}
    >
      { usedContent }
    </MUIButton>
  );
};

Button.defaultProps = {
  children: null,
  type: 'primary',
  variant: null,
  onClick: null,
  hasBorderColor: true,
  hasBorderRadius: true,
  icon: null,
  selected: false,
  text: '',
  fullWidth: false,
  overrideClass: false,
};

Button.propTypes = {
  children: node,
  variant: oneOf(['contained', 'outlined', 'text']),
  selected: bool,
  type: oneOf(['primary', 'secondary', 'tertiary']),
  onClick: func,
  hasBorderRadius: bool,
  hasBorderColor: bool,
  icon: string,
  text: string,
  fullWidth: bool,
  overrideClass: bool,
};

export default Button;
